import { jsx as _jsx } from "react/jsx-runtime";
import { CatSkeleton } from '@blocks-react/components/Skeleton';
import styles from '../../MyEquipment.module.scss';
export const VirtualLoader = ({ gapForScroll }) => {
    return (_jsx("div", { className: `${styles['virtualized_wrapper_loader']} ${gapForScroll}`, children: _jsx(CatSkeleton, { size: "xxl", "data-testid": "virtualized_skeleton" }) }));
};
